<template>
  <div>
    <h2 class="product-description">
      {{ providerName }}
    </h2>
    <!-- eslint-disable -->
    <div class="p-20 read-more-p">
      <read-more
        v-if="description"
        :more-str="readMoreLinkLabel"
        :text="description"
        link="#"
        :max-chars="200"
      ></read-more>
    </div>
  </div>
</template>

<script>
import { get, isEmpty } from "@/utils/lodash";

export default {
  props: {
    provider: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    readMoreLinkLabel() {
      return this.$i18n.t("providers.providerDescription.link");
    },
    description() {
      return get(this.provider, "content");
    },
    providerName() {
      const aliasName = get(this.provider, "name");

      return isEmpty(aliasName) ? get(this.provider, "name") : aliasName;
    },
  },
  methods: {
    goToPreviousPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
h2 {
  text-transform: uppercase;
  font-size: 24px;
  font-family: $font-family-bold-condensed;
  font-weight: 900;
  color: #333333;
  text-align: left;
  line-height: normal;
  letter-spacing: 0.6px;
  padding-left: 20px;
}
.read-more {
  font-family: $font-family-bold-condensed;
  font-size: 16px;
  font-weight: 300;
  color: $color-primary;
  text-align: left;
  line-height: normal;
  letter-spacing: 1.25px;
}
</style>
